<template>
  <div class="image-list" v-if="imageList">
    <van-swipe  lazy-render
      class="my-swipe" 
      indicator-color="white" ref="swipe"
      @change="swipChange">
        <van-swipe-item v-for="(item,index) in datamodel.value" :key="item.type+index">
          <div class="list-item-cell">
            <template v-if="registerTemplateName_SAVE.includes(`C${item.type.replace(/-/g, '')}`)">
                <component
                  v-if="item.value && item.visible"
                  :is="`C${item.type.replace(/-/g, '')}`"
                  :datamodel="item"
                  inList="true"
                  :imgWidth="imgWidth"
                  ref="childComponents"
              ></component>
              <div v-else></div>
            </template>
            <C00000000000000000000000000000000 v-else
            :datamodel="item"
            ref="childComponents">
            </C00000000000000000000000000000000>
          </div>
        </van-swipe-item>
          <template #indicator>
              <div class="indicator-container">
                  <div class="custom-indicator" v-for="index in datamodel.value.length" 
                  :key="index" 
                  :class="currentIndex == index ? 'custom-indicator-active' : 'custom-indicator'"
                  @click="swipChangeIndex(index)"
                  ></div>
              </div>
          </template>
      </van-swipe>
  </div>
  
  <div style="margin-top: 16px; margin-bottom: 16px;" v-else>
    <!-- {{datamodel.value}} -->
    <div v-for="(item,index) in datamodel.value" :key="index">
      <!-- {{item.value}} -->
      <template v-if="registerTemplateName_SAVE.includes(`C${item.type.replace(/-/g, '')}`)">

        <component
            v-if="item.value && item.visible"
            :is="`C${item.type.replace(/-/g, '')}`"
            :datamodel="item"
            inList="true"
            ref="childComponents"
        ></component>
        <div v-else></div>
      </template>
        <C00000000000000000000000000000000 v-else
        :datamodel="item"
        ref="childComponents">
        </C00000000000000000000000000000000>
    </div>
  </div>
</template>

<script>

import VSwiper from '@/components/Swiper/index.vue'
export default {
  uuid: "00000000-0000-0000-0000-000000000008",
  components: {
    VSwiper
  },
  props: ["datamodel"],
  data() {
    return {
      itemdata: "",
      callBackJson: {},
      currentIndex: 1,
    };
  },
  computed: {
    hostKey() {
      return this.fatherContent.key || ""
    },
    imageList() {
      let item = this.datamodel.value[0]
      return item.type == '00000000-0000-0000-0000-000000100005' || item.type == '00000000-0000-0000-0000-000000100006'
    },
    imgWidth() {
      return 'width:100%;'
    }
  },
  watch: {},
  methods: {
    swipChangeIndex(index) {
      console.log("swipChangeIndex", index)
      this.$refs.swipe && this.$refs.swipe.swipeTo((index - 1));
    },
    swipChange(index) {
      this.currentIndex = index + 1
    }
  },
  created() {},
  mounted() {
    setTimeout(()=>{
      this.$refs.swipe && this.$refs.swipe.resize();
      }, 1000)
  }
};
</script>
<style lang="scss">
  .van-swipe__track {
    display: flex;
  }
  .van-swipe__indicators {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 20px;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #D9D9D9;
  }
  .van-swipe__indicator {
    width: 6px;
    height: 6px;
    margin-left: 6px;
    border-radius: 6px;
    z-index: 1;
    background-color: #D9D9D9;
  }
</style>
<style lang='scss' scoped>
.image-list {
  min-height: 262px;
  // width: 100vw;
  overflow: hidden;
  position: relative;
  .list-item-cell {
    max-width: 100%; 
    display: flex; 
    justify-content: center; 
    align-items: center;
    min-height: 200px;
    // padding: 0 31px;
  }
}

// .my-swipe .van-swipe-item {
//     color: #fff;
//     font-size: 20px;
//     line-height: 150px;
//     text-align: center;
//     background-color: #39a9ed;
//   }

  .my-swipe {
    // width: 100%;
    margin-top: 16px;
    text-align: center;
}
.indicator-container {
    // margin: 16px 0;
    min-height: 22px;
    max-width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .custom-indicator {
        background-color: #F1F4F8;
        height: 4px;
        width: 60px;
        border-radius: 2px;
        &-active {
            height: 4px;
            width: 60px;
            border-radius: 2px;
            background-color: #0BBCAC;
        }
    }
}
</style>